import type { ElementType, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface ContainerProps {
    children: ReactNode
    className?: string
    as?: ElementType
    size?: 'default' | 'wide' | 'narrow'
}

const sizes = {
    narrow: 'max-w-3xl',
    default: 'max-w-6xl',
    wide: 'max-w-7xl'
}

export const Container = ({ children, className, as, size = 'default' }: ContainerProps) => {
    const Tag = (as ?? 'div') as ElementType

    return (
        <Tag className={cn('mx-auto w-full px-5 sm:px-8', sizes[size], className)}>
            {children}
        </Tag>
    )
}
